export const mapperExpectanciesToForm = expectancies => {
    return expectancies.map(expectancie => {
        const { id, current_value, date } = expectancie
        return {
            id,
            value: current_value,
            expectation: current_value,
            date,
        }
    })
}

export const mapperFormToApi = (checkIns, userId) => {
    return checkIns.map(checkIn => {
        const { value, date } = checkIn
        return {
            user_id: userId,
            current_value: value,
            date,
            type: 'simulated_accomplished',
        }
    })
}
